import toast from "react-hot-toast"

const authClient = async (endpoint, method = "GET", body = null) => {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate", // No caching at all
      Pragma: "no-cache", // Older HTTP/1.0 servers
      Expires: "0", // Ensures the response is always fresh
    },
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`
      throw new Error(errorMessage)
    }

    // Try to parse the response as JSON, if applicable
    return await response.json()
  } catch (error) {
    const message = error.message || "An unexpected error occurred."
    toast.error(message, {
      duration: 5000,
    })
    console.error("API call failed:", error)
    throw error // Rethrow the error to handle it later
  }
}

export const get = (endpoint) => authClient(endpoint, "GET")
export const post = (endpoint, body) => authClient(endpoint, "POST", body)
